import { render, staticRenderFns } from "./MakeList.vue?vue&type=template&id=63fcf3b0&scoped=true"
import script from "./MakeList.vue?vue&type=script&lang=js"
export * from "./MakeList.vue?vue&type=script&lang=js"
import style0 from "./MakeList.vue?vue&type=style&index=0&id=63fcf3b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fcf3b0",
  null
  
)

export default component.exports